import React from 'react'

export const YouTubeVideo = ({ videoId }) => (
  <div className="videowrapper">
    <iframe title="Video" src={`https://www.youtube.com/embed/${videoId}`} frameBorder="0" allowFullScreen />
  </div>
)
